import { Form, FormTextField, SearchRoundedIcon } from '@shared/components';
import debounce from 'lodash/debounce';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import { useQBankStructureSearchParams } from '../../hooks';

import type { QBankStructureListSearchFormInput } from './types';

export default function QBankStructureListSearchBox() {
  const [{ search }, setQBankStructureSearchParams] = useQBankStructureSearchParams();

  const { watch, control, handleSubmit } = useForm<QBankStructureListSearchFormInput>({
    defaultValues: { search: search ?? '' },
  });

  const setSearchParams = (formValues: QBankStructureListSearchFormInput) => {
    setQBankStructureSearchParams({
      search: formValues.search.toString().trim(),
      page: null,
    });
  };

  useEffect(() => {
    const subscription = watch(debounce((formValues) => setSearchParams(formValues), 700));

    return subscription.unsubscribe;
  }, [watch, setSearchParams]);

  return (
    <Form onSubmit={handleSubmit(setSearchParams)} sx={{ maxWidth: 300, width: '100%' }}>
      <FormTextField
        placeholder='ค้นหาคลังข้อสอบ'
        name='search'
        control={control}
        slotProps={{
          input: {
            startAdornment: (
              <SearchRoundedIcon sx={{ color: (theme) => theme.palette.grey[500] }} />
            ),
            // TODO: control styling from parent instead of self-define like this
            sx: { minHeight: 46, width: 300 },
          },
        }}
        fullWidth
      />
    </Form>
  );
}
